import { Award } from "lucide-react";
import alexanderSteinImage from "@/assets/alexander-stein.webp";

export const AboutSEO = () => {
  return (
    <section id="uber-uns" className="py-16 md:py-24 lg:py-32 bg-muted/20">
      <div className="container mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Text */}
          <div>
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-muted-foreground mb-4 block">
              Warum Malermeister Stein?
            </span>
            <h2 className="font-caslon text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-foreground">
              Leidenschaft für Handwerk.<br />Präzision im Detail.
            </h2>
            <p className="text-lg text-muted-foreground mb-6 leading-relaxed">
              Als Malermeister stehe ich mit meinem Namen für Qualität in Herford. 
              Meine Leidenschaft gilt den schwierigen Fällen: Schimmelsanierung, hocheffiziente 
              Fassadendämmung und exklusive Oberflächengestaltung.
            </p>
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
              Unser Versprechen: Sauberkeit auf der Baustelle, Termintreue und eine 
              Beratung, die Ihnen alle Optionen transparent aufzeigt. So arbeiten wir – 
              bei jedem Projekt.
            </p>

            {/* Key differentiators */}
            <div className="grid sm:grid-cols-2 gap-3">
              {[
                "Spezialist für Fassadendämmung",
                "Experte für Schimmelsanierung",
                "Meistergeführter Betrieb",
                "24h Rückruf-Service"
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3 py-2">
                  <div className="w-1.5 h-1.5 bg-foreground rounded-full shrink-0" />
                  <span className="font-medium text-foreground text-sm">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="rounded-xl overflow-hidden">
              <img 
                src={alexanderSteinImage} 
                alt="Malermeister Alexander Stein – Geschäftsführer Malerfachbetrieb Stein Herford"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-foreground text-background p-8 rounded-xl shadow-xl hidden lg:block">
              <div className="text-5xl font-bold mb-2">10+</div>
              <div className="text-sm font-medium tracking-wide">Jahre<br />Erfahrung</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
